module.exports = __webpack_public_path__ + "img/9299f96af0e1405e32f8442bd59bc7ca.png";